/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="153.57"
        height="53.01"
        viewBox="0 0 153.57 53.01"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="m70.4 1.65.43-.09c.84-.18 1.69-.35 2.54-.5l1-.16c11.52-1.87 22.85-.84 27 3.32l4.32 4.35 4.58 4.67 1.66 1.69a1.25 1.25 0 1 1-1.68 1.84l-.1-.09-3.33-3.38-4.25-4.38-2-2.07-.86-.85c-3-3-11.59-4.11-21-3.15l-1 .11c-2.1.25-4.25.59-6.36 1.05l-.49.11-.54.13a65.07 65.07 0 0 0-41.36 33.27l-.28.56a4.44 4.44 0 0 0-.5 2.12 4.67 4.67 0 0 0 4.43 4.67h11.85a1.24 1.24 0 0 1 1.32 1.17 1.26 1.26 0 0 1-1.17 1.33h-11.8a7.18 7.18 0 0 1-7.17-7.17 7 7 0 0 1 .77-3.2A67.65 67.65 0 0 1 69.68 1.82l.61-.15ZM114.08 44.89a1.25 1.25 0 0 1 .13 2.49H64.28a1.25 1.25 0 0 1-1.23-1.27 1.27 1.27 0 0 1 1.1-1.22Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M54.35 27.01a13 13 0 1 0 13 13 13 13 0 0 0-13-13Zm0 2.5a10.46 10.46 0 1 1-10.46 10.46 10.46 10.46 0 0 1 10.46-10.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M54.35 32.78a7.17 7.17 0 1 1 .53 14.33 4.68 4.68 0 0 1-.53 0 1 1 0 0 1 0-2 5.17 5.17 0 1 0-5.17-5.17 1 1 0 1 1-2 0 7.17 7.17 0 0 1 7.17-7.16Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M124.02 27.01a13 13 0 1 0 13 13 13 13 0 0 0-13-13Zm0 2.5a10.46 10.46 0 1 1-10.45 10.47 10.46 10.46 0 0 1 10.45-10.46Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M124.02 32.78a7.17 7.17 0 1 1 .53 14.33 4.68 4.68 0 0 1-.53 0 1 1 0 0 1 0-2 5.17 5.17 0 1 0-5.17-5.17 1 1 0 0 1-2 0 7.17 7.17 0 0 1 7.17-7.16ZM36.14 14.6a1.25 1.25 0 0 1 1.25 1.25 1.27 1.27 0 0 1-1.13 1.25h-21.4a1.24 1.24 0 0 1-1.22-1.28 1.26 1.26 0 0 1 1.1-1.21h21.4ZM21.51 30.71a1.25 1.25 0 0 1 .12 2.48H7.28a1.242 1.242 0 0 1-.13-2.48ZM26.62 22.94a1.25 1.25 0 0 1 .13 2.49H1.32A1.25 1.25 0 0 1 0 24.25a1.27 1.27 0 0 1 1.19-1.32h25.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m144.47 20.58 1.85 1.68a6.4 6.4 0 0 0-1.75 4.32c0 3.68 3.27 6.74 7.41 6.85h.26v2.5c-5.59 0-10.17-4.16-10.17-9.35a9 9 0 0 1 2.14-5.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M125.96 14.58c10.3 0 17.66 2.77 22.28 7.72a20.26 20.26 0 0 1 5.3 13.45v3.26a8.42 8.42 0 0 1-8.18 8.41h-11.4a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21h11.36a5.93 5.93 0 0 0 5.93-5.67v-3a17.82 17.82 0 0 0-4.66-12.25c-4-4.32-10.56-6.82-19.9-6.91H44.89a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31h81.09Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'CarMovingIcon';

export default Icon;
